module.exports = __webpack_public_path__ + "img/banner4-03.4943a253.jpg";